import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaTwitter = props => {
  if (props.id !== "_svgsocialmediatwitter") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><g fill="#333"><path d="M120 15C62.562 15 16 61.562 16 119s46.562 104 104 104 104-46.562 104-104S177.438 15 120 15zm0 196c-50.729 0-92-41.271-92-92s41.271-92 92-92 92 41.271 92 92-41.271 92-92 92z" /><path d="M171.907 85.445c5.42-3.249 9.584-8.394 11.543-14.525a52.563 52.563 0 01-16.671 6.371A26.222 26.222 0 00147.614 69c-14.5 0-26.255 11.755-26.255 26.254 0 2.059.23 4.062.68 5.983-21.821-1.094-41.167-11.547-54.116-27.431a26.12 26.12 0 00-3.555 13.199c0 9.109 4.635 17.145 11.68 21.853a26.14 26.14 0 01-11.892-3.284c-.002.11-.002.22-.002.33 0 12.721 9.051 23.333 21.062 25.745a26.299 26.299 0 01-11.857.449c3.341 10.43 13.037 18.021 24.526 18.233a52.676 52.676 0 01-32.607 11.237c-2.12 0-4.209-.123-6.264-.365C70.633 168.652 84.434 173 99.261 173c48.292 0 74.7-40.007 74.7-74.701a75.06 75.06 0 00-.076-3.397 53.345 53.345 0 0013.102-13.591 52.51 52.51 0 01-15.08 4.134z" /></g></svg>;
};

SvgSocialmediaTwitter.displayName = "_svgsocialmediatwitter";
SvgSocialmediaTwitter.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaTwitter.defaultProps = {
  id: ''
};
export default SvgSocialmediaTwitter;